import React from "react";
// import { TextInputError } from "../../../store/types/misc";

type IItems = {
  id: string | number;
  name: string;
};

type ISelectButton = {
  name: string;
  items: IItems[];
  label?: string;
  required?: boolean;
  value: string | number;
  status?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: () => void;
  disabled?: boolean;
  error?: string;
};

const SelectDropdown: React.FC<ISelectButton> = ({
  value,
  onChange,
  onBlur,
  items,
  status,
  name,
  label,
  required,
  disabled,
  error,
}) => {
  const hasError = Boolean(error) || Boolean(status);

  // Base classes that are always applied
  const baseClasses =
    "mt-1 py-3 px-4 text-15 text-borderBColor border bg-transparent block w-full rounded-[10px] shadow-custom focus:ring focus:ring-[#E5F4F7] focus:ring-opacity-50";

  // Conditional classes based on state
  const borderClass = hasError
    ? "border-[red] focus:border-[red]"
    : "border-[#0B60D6] focus:border-[#1E1E1E]";
  // [rgb(232, 232, 232)];
  const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <div className="mb-2 font-abel">
      {label && (
        <label
          className="text-15 text-[#1E1E1E] block text-borderBColor capitalize mb-1"
          htmlFor={name}
        >
          {label} {required && <span className="text-[red]">*</span>}
        </label>
      )}
      <select
        name={name}
        className={`${baseClasses} ${borderClass} ${disabledClass}`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        aria-invalid={hasError}
        aria-describedby={hasError ? `${name}-error` : undefined}
      >
        <option value="">Select...</option>
        {items.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      {/* {hasError && (
        <p
          id={`${name}-error`}
          className="text-[red] text-[12px] mt-1"
          role="alert"
        >
          {error || status}
        </p>
      )} */}
    </div>
  );
};

export default SelectDropdown;
